var heading_default = {
  "fontElementMap": "_3nulP",
  "elementSpacing": "mQBhS",
  "headerOne": "TBrTV mQBhS",
  "headerTwo": "iEL0U mQBhS",
  "headerThree": "GyCbZ mQBhS",
  "headerFour": "CO3Y9 mQBhS",
  "headerFive": "n4Ls5 mQBhS",
  "headerSix": "r6Ca1 mQBhS",
  "child": "B6N5M"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
